import React from "react";
import "./style.css";

function Content({ data }) {
  return (
    <div className="project-description-container">
      <h3>{data.project}</h3>
      <h4>{data.title}</h4>
      <p>{data.description}</p>
      <ul>
        {data.works.map((work) => {
          return <li>{work}</li>;
        })}
      </ul>
    </div>
  );
}

export default Content;
